import { api } from "./axios.config";
import axios from "./axios";
import { getCurrentEventId } from "../Utils/helpers";

const API_URL = api.apiUrl;
const BASE_URL = "/event";

export const createWidget = async (data) => {
    const eventId = getCurrentEventId();
    return axios.post(`${API_URL}${BASE_URL}/${eventId}/widget`, data);
};

export const getWidgets = async () => {
    const eventId = getCurrentEventId();
    return axios.get(`${API_URL}${BASE_URL}/${eventId}/widget`);
};

export const updateWidget = async (widgetId, data) => {
    const eventId = getCurrentEventId();
    return axios.put(`${API_URL}${BASE_URL}/${eventId}/widget/${widgetId}`, data);
};

export const deleteWidget = async (widgetId) => {
    const eventId = getCurrentEventId();
    return axios.delete(`${API_URL}${BASE_URL}/${eventId}/widget/${widgetId}`);
};
